import type { BaseKeyFunction } from "../../../../lib/types/baseKeyFunction";
import type { CommunityType } from "../../../../lib/types/enums/community/communityType";

export type KeyCommunitiesChildrenProps = {
  id: number;
  type: CommunityType;
};

export const keyCommunitiesChildren: BaseKeyFunction<
  KeyCommunitiesChildrenProps
> = ({ id, type }) => ["communities-children", id.toString(), type];
